import styles from "./Addons.module.scss";
import MainTitle from "../../../components/ui/MainTitle/MainTitle";
import { useTranslation } from "react-i18next";
import plusIconOrange from "../../../assets/images/icons/plus-orange.svg";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import React, { useEffect, useState } from "react";
import AddonPopup from "./AddonPopup/AddonPopup";
import { useLocation, useNavigate } from "react-router-dom";
import AddonItem from "./AddonItem/AddonItem";
import { useGetAllAddonsQuery } from "../../../api/queries";
import AddonsEmpty from "./AddonsEmpty/AddonsEmpty";

const Addons = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [showCreateAddonPopup, setShowCreateAddonPopup] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string | null>(null);
  const { data: addonList = [], refetch, isLoading } = useGetAllAddonsQuery(searchValue);

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const shouldUpdate = searchParams.get("shouldUpdateAddons");
      if (searchParams.get("searchValue") !== searchValue) {
        setSearchValue(searchParams.get("searchValue"));
      }
      if (shouldUpdate) {
        refetch();
      }
      navigate("/subscriptions");
    }
  }, [location]);

  const onClickAddNew = () => {
    setShowCreateAddonPopup(true);
  };

  return (
    <div className={"page-content"}>
      <div className={styles.top}>
        <MainTitle
          text={t("Addons")}
          subtitleText={t("OptionalExtrasClientsCanAttachToSubscription")}
        />
        <div className={styles.btnWrapper}>
          <CustomButton
            text={t("AddAddon")}
            type={"button"}
            typeStyle={"outline"}
            icon={plusIconOrange}
            altIcon={"add"}
            functionOnClick={onClickAddNew}
          />
        </div>
      </div>
      <div className={styles.wrapper}>
        {!!addonList.length &&
          addonList.map((el) => {
            return <AddonItem key={el.id} item={el} />;
          })}
      </div>
      {addonList.length === 0 && !isLoading && <AddonsEmpty onClickAddNew={onClickAddNew} />}
      {showCreateAddonPopup && (
        <AddonPopup setShowCreatePopup={setShowCreateAddonPopup} item={null} />
      )}
    </div>
  );
};

export default Addons;
